import ModuleLayout from "../../components/enterprise/ModuleLayout";
import { analyticsTabs } from "../navigation";
import { useTranslation } from "react-i18next";

const AnalyticsModulePage = ({ title, subtitle, children, dataMode = { mode: "real" } }) => {
  const { t } = useTranslation();
  return (
    <ModuleLayout title={title} subtitle={subtitle} breadcrumbs={[t("platform.nav.analytics"), title]} tabs={analyticsTabs} dataMode={dataMode}>
      {children}
    </ModuleLayout>
  );
};

export default AnalyticsModulePage;
